module.exports = __webpack_public_path__ + "hero-down.36ee3c23.mp3";